/**
 * @file 直播 - 基本信息
 */
import { DatePicker, Form, Input, TimePicker } from 'antd'

import { rulesMap } from 'packages/utils'

import { CommonBasicInfo } from '@/components/CommonBasicInfo'

import { BasicInfoProps } from '../types'
import { EntryComponentsWrapper } from 'packages/theme'
import styled from 'styled-components'

/**
 * 直播 - 基本信息
 *
 * @param param0 - 参数
 * @param param0.form - 表单实例
 * @param param0.basicInfoRef - 基本信息 ref
 * @param param0.commonBasicInfo - 基本信息
 * @param param0.setTitle - 设置标题
 * @param param0.activityTaskOptions - 任务选项
 * @param param0.openTypeDisabled - 是否开启开启设置
 * @returns  component
 */
export const BasicInfo: React.FC<
  BasicInfoProps & {
    openTypeDisabled?: boolean
  }
> = ({
  form,
  basicInfoRef,
  commonBasicInfo,
  setTitle,
  activityTaskOptions,
  openTypeDisabled,
}) => {
  return (
    <Wrapper>
      <Form
        colon={false}
        form={form}
        wrapperCol={{ span: 22 }}
        labelCol={{ span: 2 }}
        initialValues={{
          isShow: true,
        }}
      >
        <Form.Item
          label="直播标题"
          name="name"
          rules={[{ required: true, message: '请输入直播标题' }]}
        >
          <Input
            placeholder="请输入直播标题"
            onChange={(e) => {
              setTitle && setTitle(e.target.value)
            }}
            maxLength={200}
          />
        </Form.Item>
        <Form.Item
          label="直播时间"
          required={true}
          style={{ marginBottom: 0 }}
        >
          <Form.Item
            name={['liveTime', 'liveDate']}
            style={{ display: 'inline-block', width: '398px' }}
            rules={[{ required: true, message: '请选择日期' }]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item
            name={['liveTime', 'liveTimes']}
            style={{
              display: 'inline-block',
              width: '398px',
              marginLeft: '12px',
            }}
            rules={[{ required: true, message: '请选择时间' }]}
          >
            <TimePicker.RangePicker
              format={'HH:mm'}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item
          label="直播链接"
          name="liveLink"
          rules={[
            { required: true, message: '请输入直播链接' },
            ...rulesMap['url'],
          ]}
        >
          <Input
            placeholder="请输入直播链接"
            style={{ width: 400 }}
          />
        </Form.Item>
        <CommonBasicInfo
          form={form}
          ref={basicInfoRef}
          value={commonBasicInfo}
          activityTaskOptions={activityTaskOptions || []}
          openTypeDisabled={!!openTypeDisabled}
        />
      </Form>
    </Wrapper>
  )
}

const Wrapper = styled(EntryComponentsWrapper)`
  &&& {
    .ant-form-item-label {
      margin-right: 12px;
    }
  }
`
